<script>
  import { fly } from 'svelte/transition';
  import {
    alertReload,
    idTrappe,
    currentLocation,
    pathTrappe,
  } from './stores.js';
  import Header from './Components/Header.svelte';
  import Prefooter from './Components/prefooter.svelte';
  import { resetTrappeOption } from './Utils/saveInDb';
  import { asnavigate } from './Utils/asnavigation.js';
  import { useNavigate, useLocation } from 'svelte-navigator';
  const navigate = useNavigate();

  import Choixstatus from './Process/Choixstatus.svelte';
  import ParticulierCoordonees from './Process/ParticulierCoordonees.svelte';
  import ParticulierRecapitulatif from './Process/ParticulierRecapitulatif.svelte';
  import ProfessionnelCoordonees from './Process/ProfessionnelCoordonees.svelte';
  import ProfessionnelRecapitulatif from './Process/ProfessionnelRecapitulatif.svelte';
  import NegociantIdentification from './Process/NegociantIdentification.svelte';
  import NegociantRecapitulatif from './Process/NegociantRecapitulatif.svelte';

  export let processStatus;
  export let processStep;
  console.log(`Process status : ${processStatus}`);
  console.log(`Process step : ${processStep}`);

  $alertReload = true;

  const location = useLocation();

  $: {
    $currentLocation = $location.pathname;
    console.log($pathTrappe);
  }

  if ($idTrappe.length === 0) {
    console.log(`<!-- ===+++ Trappe options empty +++=== -->`);
    resetTrappeOption();
    asnavigate(navigate, '/LayoutPage');
  }
</script>

<!-- <Header /> -->
<!-- <div class="bg-diago"></div> -->

<!-- <div class="as-main-section as-container relative mx-auto" style="z-index:10;"> -->
<div class="as-process relative" style="z-index:10;">
  <!-- <div class="container-lg  mx-auto"> -->
  <div class="as-main-section relative mx-auto">
    <div class="text-left mt-24"></div>
    <div in:fly="{{ x: 50, duration: 500 }}">
      <div class="as-container as-container-titre relative mx-auto">
        {#if processStep == ''}
          {#if processStatus == ''}
            <div class="as-titre">Choisissez votre statut</div>
          {:else if processStatus == 'particulier'}
            <div class="as-titre">Particulier</div>
          {:else if processStatus == 'professionnel'}
            <div class="as-titre">Entreprise</div>
          {:else if processStatus == 'negociant'}
            <div class="as-titre">Négociant</div>
          {/if}
        {:else if processStep == 'coordonnees'}
          <div class="as-titre">Veuillez indiquer vos coordonnées</div>
        {:else if processStep == 'recapitulatif'}
          <div class="as-titre">Récapitulatif pour devis</div>
        {:else if processStep == 'identification'}
          <div class="as-titre">Veuillez vous identifier</div>
        {/if}
      </div>
    </div>
    <div in:fly="{{ x: 50, duration: 600 }}">
      {#if processStep == ''}
        <div class="as-container as-container-form relative mx-auto pd-10">
          <Choixstatus />
        </div>
      {:else if processStatus == 'particulier' && processStep == 'coordonnees'}
        <div class="as-bg-bloc relative" style="z-index:10;">
          <div class="as-container relative mx-auto">
            <ParticulierCoordonees />
          </div>
        </div>
      {:else if processStatus == 'particulier' && processStep == 'recapitulatif'}
        <div class="as-bg-bloc relative" style="z-index:10;">
          <div class="as-container relative mx-auto">
            <ParticulierRecapitulatif />
          </div>
        </div>
      {:else if processStatus == 'professionnel' && processStep == 'coordonnees'}
        <div class="as-bg-bloc relative" style="z-index:10;">
          <div class="as-container relative mx-auto">
            <ProfessionnelCoordonees />
          </div>
        </div>
      {:else if processStatus == 'professionnel' && processStep == 'recapitulatif'}
        <div class="as-bg-bloc relative" style="z-index:10;">
          <div class="as-container relative mx-auto">
            <ProfessionnelRecapitulatif />
          </div>
        </div>
      {:else if processStatus == 'negociant' && processStep == 'identification'}
        <div class="as-bg-bloc relative" style="z-index:10;">
          <div class="as-container relative mx-auto">
            <NegociantIdentification />
          </div>
        </div>
      {:else if processStatus == 'negociant' && processStep == 'recapitulatif'}
        <div class="as-bg-bloc relative" style="z-index:10;">
          <div class="as-container relative mx-auto">
            <NegociantRecapitulatif />
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>

<Prefooter />

<style>
  .as-titre {
    position: relative;
    font-family: 'introblack';
    font-size: 35px;
    line-height: 30px;
  }
  .as-titre::after {
    content: '';
    position: absolute;
    inset: auto auto -15px 0;
    border: 4px solid #000;
    width: 40px;
  }
  @media only screen and (max-width: 768px) {
    .as-container-titre {
      padding: 0 30px;
    }
  }
</style>
